// components/DocumentStructure.jsx
import React from "react";
import { Document, Page, Font } from "@react-pdf/renderer";
import CoverPage from "../Pages/CoverPage";
import Overview from "../Pages/Overview";
import BreakdownPage from "../Pages/Breakdown";
import OutfitRegular from "../fonts/Outfit/static/Outfit-Regular.ttf";
import OutfitMedium from "../fonts/Outfit/static/Outfit-Medium.ttf";
import OutfitSemiBold from "../fonts/Outfit/static/Outfit-SemiBold.ttf";

import RalewayRegular from "../fonts/Raleway/static/Raleway-Regular.ttf";
import RalewayMedium from "../fonts/Raleway/static/Raleway-Medium.ttf";
import RalewaySemiBold from "../fonts/Raleway/static/Raleway-SemiBold.ttf";

// 1) Register your fonts:
Font.register({
  family: "Outfit",
  fonts: [
    { src: OutfitRegular, fontWeight: 400 },
    { src: OutfitMedium, fontWeight: 500 },
    { src: OutfitSemiBold, fontWeight: 600 },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    { src: RalewayRegular, fontWeight: 400 },
    { src: RalewayMedium, fontWeight: 500 },
    { src: RalewaySemiBold, fontWeight: 600 },
  ],
});

const DocumentStructure = ({
  orgData,
  calculatedData,
  prevDataCalculated,
  anchor,
}) => {
  return (
    <Document>
      <CoverPage companyName={orgData?.organization?.name} anchor={anchor} />
      <Overview
        data={calculatedData?.summary}
        prevData={prevDataCalculated?.summary}
        overviewData={calculatedData?.outcomesBreakdown}
        prevOverviewData={prevDataCalculated?.outcomesBreakdown}
      />
      {calculatedData?.questionBreakdown?.map((data, index) => {
        const prevData = prevDataCalculated?.questionBreakdown?.[index];
        return data?.factors?.map((factor, index) => {
          const prevFactor = prevData?.factors?.[index];
          return <BreakdownPage data={factor} prevData={prevFactor} />;
        });
      })}
      {/* Add other pages here as separate components */}
      {calculatedData?.outcomesBreakdown?.map((data, index) => {
        const prevData = prevDataCalculated?.outcomesBreakdown?.[index];
        return <BreakdownPage data={data} prevData={prevData} />;
      })}
    </Document>
  );
};

export default DocumentStructure;
